export default __webpack_public_path__ + "static/media/RU.59b2a7f0.ico";